import Slick from 'vue-slick';
import EventColumn from '../../../../events/EventColumn/EventColumn';

export default {

  name: 'event-highlights-block',

  props: {
    block: {}
  },

  components: {
    'coe-highlights': Slick,
    'event-column': EventColumn
  },

  inject: [
    'eventsData',
    'promises'
  ],

  data () {
    return {
      eventHighlights: null,
      isLoading: true,
      slickOptions: {
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        slidesToScroll: 4,
        autoplay: false,
        infinite: true,
        fade: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },

  methods: {
    getEventHighlights: function () {
      let event = null;
      let eventCategories = null;
      let categoryItem = null;
      let highlightsFiltered = [];
      for (event in this.eventsData.events) {
        eventCategories = this.eventsData.events[event].categories;
        for (categoryItem in eventCategories) {
          if (eventCategories[categoryItem].slug === 'highlights') {
            highlightsFiltered.push(this.eventsData.events[event]);
          }
        }
      }
      this.eventHighlights = highlightsFiltered;
    }
  },

  created () {
    let proxy = this;
    this.promises.events.promise.then(function () {
      proxy.getEventHighlights();
      proxy.isLoading = false;
    });
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/eventHighlightsBlock/EventHighlightsBlock.js